import styled, { css, keyframes } from 'styled-components';
import { images } from '../../../Constants/ImageUrls';

export const VideoThumbnailSection = styled.div`
  position: ${(props) => (props.allReviews ? 'unset' : 'relative')};

  margin: ${(props) =>
    props.motherTrust ? '10px 0 20px' : props.aplus ? '20px 0 40px' : '40px 0'};
  border-bottom: ${(props) =>
    props.allReviews ? '1px solid #d5d5d5' : 'none'};
  &.allReviewsDesktop {
    position: unset;
    margin: 20px 0 30px;
    border-bottom: 1px solid #d5d5d5;
    padding-bottom: 20px;
  }
  @media (max-width: 720px) {
    margin: ${(props) =>
      props.motherTrust
        ? '10px 0px 0px 6px'
        : props.allReviews
          ? '10px 0 20px 0'
          : '10px 0 30px 0'};
    border-bottom: ${(props) =>
      props.allReviews ? '1px solid #d5d5d5' : 'none'};
    padding-bottom: ${(props) => (props.allReviews ? '16px' : '0')};
  }
`;

export const GreenTitleSection = styled.div`
  padding-bottom: 12px;

  @media (max-width: 720px) {
    padding-left: 10px;
  }
`;
export const VideoRelativeContainer = styled.div`
  position: relative;

  .cross {
    position: absolute;
    width: 30px;
    height: 30px;
    background: #fff;
    border-radius: 50%;
    line-height: 30px;
    font-size: 44px;
    color: #00000087;
    top: ${(props) => (props.categoryPage ? '0' : '20px')};
    right: ${(props) => (props.categoryPage ? '0' : '20px')};
    cursor: pointer;
    text-align: center;

    @media (max-width: 720px) {
      cursor: default;
      font-size: 30px;
      top: ${(props) => (props.categoryPage ? '0' : '-34px')};
      right: ${(props) => (props.categoryPage ? '0' : '11px')};
    }
  }
`;

export const ThumbnailContainer = styled.div`
  flex-basis: ${(props) =>
    props.resultNew
      ? '21%'
      : props.allReviews
        ? '18%'
        : props.aplus
          ? '28%'
          : props.category
            ? '25%'
            : '23%'};
  flex-shrink: 0;
  margin-right: ${(props) =>
    props.allReviews
      ? '16px'
      : props.aplus
        ? '20px'
        : props.categoryL1Container
          ? '0'
          : '30px'};
  padding: ${(props) =>
    props.allReviews || props.motherTrust
      ? '0'
      : props.aplus
        ? '0 0 0 10px'
        : '0'};
  ${(props) =>
    props.categoryL1Container
      ? css`
          width: 80%;
          margin: auto;
          @media (max-width: 720px) {
            width: 100%;
            margin: auto;
          }
        `
      : null}

  /* height: ${(props) => (props.aplus ? '298px' : '460px')}; */
    position: ${(props) => (props.allReviews ? 'unset' : 'relative')};
  overflow: hidden;
  cursor: pointer;
  border-radius: 4px;
  transition:
    transform 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
    box-shadow 0.3s ease 0s;

  &:hover {
    transform: ${(props) =>
      props.location == 'category' ? 'scale(1)' : 'scale(1.02)'};
  }
  scroll-snap-align: center;
  @media (max-width: 720px) {
    flex-basis: ${(props) =>
      props.resultNew
        ? '65%'
        : props.motherTrust
          ? '47%'
          : props.allReviews
            ? '28%'
            : props.category
              ? '65%'
              : '43%'};
    margin-right: 0;
    padding: 0 6px;
    cursor: default;
  }

  .thumb_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
    filter: brightness(0.8);

    @media (max-width: 720px) {
      transform: scale(1);
    }
  }
  .thumbDiv {
    position: relative;
    width: 100%;
    height: 260px;
    background: url(${(props) =>
        props.placeholderImageMobile || images.defaultImage})
      center center no-repeat;
    background-size: cover;

    @media (min-width: 720px) {
      background: url(${(props) =>
          props.placeholderImageDesktop || images.defaultImage})
        center center no-repeat;
      background-size: cover;
    }

    ${(props) =>
      props.category
        ? `padding-top:150%;
                box-shadow: 0 2px 2px 0 rgba(0, 109, 54, 0.12);`
        : css`
            & span {
              width: 100% !important;
              padding-top: ${(props) =>
                props.motherTrust ? '175% !important' : ''};
              height: ${(props) =>
                props.allReviews
                  ? '141px'
                  : props.bannerVideo
                    ? '400px'
                    : props.motherTrust
                      ? '0'
                      : '260px'}!important;
              position: unset !important;
              @media (max-width: 720px) {
                width: 143px !important;
                height: ${(props) =>
                  props.allReviews
                    ? '90px'
                    : props.motherTrust
                      ? '0'
                      : '260px'}!important;
              }
            }
            img {
              ${(props) =>
                props.bannerVideo
                  ? css`
                      width: 60%;
                    `
                  : css`
                      background-size: cover;
                      background-image: url('https://images.myloapp.in/NestJsUploads/1701860785118-1668581912764-defaultimage-(1).webp');
                    `};
            }
          `}
  }

  .play_icon {
    width: clamp(50px, 5vw, 74px);
    height: clamp(50px, 5vw, 74px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }
  & .lowOpacity {
    opacity: 0.4;
  }

  @media (min-width: 768px) {
    width: ${(props) => (props.location == 'category' ? '80%' : 'inherit')};
    margin: auto;
  }
`;

export const VideoCaption = styled.p`
  font-size: 12px;
  font-weight: 500;
  padding: 7px 4px 0;
  color: hsl(0deg, 0%, 0%, 87%);
  display: ${(props) => (props.allReviews ? 'none' : '-webkit-box')};
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
`;

export const VideoContainer = styled.iframe`
    width: 100%;
    max-width: ${(props) => (props.categoryPage ? '100%' : '900px')};
    height: 520px;
    height: ${(props) => (props.categoryPage ? '400px' : 'unset')};
    min-height: ${(props) => (props.categoryPage ? '260px' : '360px')};
    max-height: ${(props) => (props.categoryPage ? '560px' : 'unset')};
    height: ${(props) => (props.increaseRatio ? '700px' : '')};

    @media (max-width: 720px) {
        aspect-ratio: 1;
        height: ${(props) => (props.categoryPage ? '260px' : '')};
        height: ${(props) => (props.increaseRatio ? '500px' : '')};    
        }
    }
`;
export const LeftVideoTitle = styled.h3`
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
  padding: 0 0 18px 0px;
  font-size: 16px;
  @media (max-width: 720px) {
    padding: 0 0 12px 10px;
  }
`;

export const VideoDuration = styled.div`
  position: absolute;
  bottom: 35px;
  left: 8px;
  color: #fff;
  font-size: 14px;
  display: ${(props) => (props.allReviews ? 'none' : 'block')};
  @media (min-width: 720px) {
    bottom: 30px;
  }
`;

export const ReviewsOnVideos = styled.div`
  position: absolute;
  bottom: 10px;
  left: 8px;
  z-index: ${(props) => (props.reviewImage ? ' 20' : 'unset')};
  @media (min-width: 720px) {
    bottom: 6px;
  }
  display: ${(props) => (props.allReviews ? 'none' : 'block')};
`;

export const VideoStar = styled.img`
  width: clamp(16px, 4vw, 18px);
  height: clamp(16px, 4vw, 18px);
  margin-right: 3px;
  background: none !important;
`;

const pulseBorder = keyframes`
 0% {
    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
    opacity: 1;
  }
  100% {
    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1.5);
    opacity: 0;
  }
`;
const pulseBorderNew = keyframes`
 0% {
    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
    opacity: 1;
  }
  100% {
    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(2);
    opacity: 0;
  }
`;

export const VideoPlayButton = styled.div`
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  box-sizing: content-box;
  display: block;
  width: 32px;
  height: 44px;
  /* background: #fa183d; */
  border-radius: 50%;
  padding: 43px 20px 18px 40px;

  &:before {
    content: '';
    position: absolute;
    z-index: 0;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    display: block;
    width: ${(props) => (props.allReviews ? '20px' : '40px')};
    height: ${(props) => (props.allReviews ? '20px' : '40px')};
    background: #fff;
    border-radius: 50%;
    animation: ${(props) => (props.bannerVideo ? pulseBorderNew : pulseBorder)}
      1500ms ease-out infinite;
  }

  &:after {
    content: '';
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    display: block;
    width: ${(props) => (props.allReviews ? '20px' : '40px')};
    height: ${(props) => (props.allReviews ? '20px' : '40px')};
    background: #fff;
    border-radius: 50%;
    transition: all 200ms;
  }

  &:hover {
    &:after {
      background-color: darken(#fa183d, 10%);
    }
  }

  /* p {
        display: block;
        position: relative;
        z-index: 3;
        width: 0;
        height: 0;
        border-top: 9px solid transparent;
        border-bottom: 9px solid transparent;
        border-left: 15px solid #ef4e5e;
    } */

  img {
    width: ${(props) => (props.allReviews ? '18px' : '36px')};
    width: ${(props) => (props.allReviews ? '18px' : '36px')};
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 9;
    transform: translate(-50%, -50%);
  }
`;
